import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { Constants } from '../../constants/constants';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { FileModel } from 'src/app/models/file.model';



@Component({
  selector: 'modal-image-upload',
  templateUrl: './modal-image-upload.component.html',
  styleUrls: ['./modal-image-upload.component.scss'],
})
export class ModalImageUploadComponent implements OnInit {

  imageChangedEvent: any = '';
  croppedImage: any = '';
  buttonText = "Upload";

  uploadUrl = null;
  assetUid = null;
  jobUid = null;
  reportUid = null;
  resource = "";

  constructor(private router: Router, public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController,
   public assetService: AssetService, public clientService: ClientService) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    if (this.uploadUrl)
    {
      this.buttonText = "Upload";
    }
    else
    {
      this.buttonText = "Save";
    }
  }


  fileChangeEvent(event: any): void 
  {
    this.imageChangedEvent = event;
  }


  imageCropped(event: ImageCroppedEvent) 
  {
      this.croppedImage = event.base64;
  }


  imageLoaded() 
  {
      // show cropper
  }


  cropperReady() 
  {
      // cropper ready
  }


  loadImageFailed() 
  {
      // show message
  }


  ionViewWillLeave()
  {

  }


  uploadImage()
  {
    if (this.uploadUrl)
    {
      var payload = {
        base64: this.croppedImage,
        clientUid: this.clientService.getClientUid(),
        organisationUid: this.clientService.getOrganisationUid(),
        assetUid: this.assetUid,
        jobUid: this.jobUid,
        reportUid: this.reportUid
      }

      if(this.resource == 'report')
      {
        this.uplodReportImage(payload);
      }
      else if (this.resource == 'asset')
      {
        this.uplodAssetImage(payload);
      }

    }
    else
    {
      var newFile       = new FileModel();
      newFile.base64    = this.croppedImage;

      var returnData = { addedFile: newFile };
      this.closeModal(returnData);
    }
  }

  uplodReportImage(payload)
  {
    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.uploadReportImage(payload, this.uploadUrl).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.appearanceService.presentToast("Image Uploaded", Constants.TOAST_SUCCESS);

          var newFile       = new FileModel();
          newFile.s3Path    = response.s3Path;
          newFile.base64    = this.croppedImage;
          newFile.fileName  = response.filename;
          newFile.fileType  = response.fileType;
          newFile.datetime  = response.datetime;
          newFile.uid       = Number(response.fileUid);

          var returnData = { addedFile: newFile };
          this.closeModal(returnData);
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }

  uplodAssetImage(payload)
  {
    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.uploadAssetImage(payload, this.uploadUrl).subscribe(response => {

        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          this.appearanceService.presentToast("Image Uploaded", Constants.TOAST_SUCCESS);

          var newFile       = new FileModel();
          newFile.s3Path    = response.s3Path;
          newFile.base64    = this.croppedImage;
          newFile.fileName  = response.filename;
          newFile.fileType  = response.fileType;
          newFile.datetime  = response.datetime;
          newFile.uid       = Number(response.fileUid);

          var returnData = { addedFile: newFile };
          this.closeModal(returnData);
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'ImageUploadModal');
  }
}
